var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "165.000000pt",
    height: "115.000000pt",
    viewBox: "0 0 165.000000 115.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,115.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 1109 l-29 -30 0 -425 0 -426 33 -29 c29 -26 39 -29 102 -29 47 0 70 -4 70 -12 0 -6 9 -31 21 -55 31 -64 91 -97 168 -91 85 6 128 42 161 131 l10 27 291 -2 291 -3 13 -38 c15 -44 48 -82 87 -103 35 -18 121 -18 157 0 39 21 88 79 96 115 6 29 8 30 73 33 l67 3 3 227 2 227 -71 117 c-45 73 -83 123 -103 135 -27 17 -52 19 -218 19 l-186 0 -4 91 c-3 88 -4 92 -36 120 l-32 29 -468 0 -468 0 -30 -31z m970 -20 l26 -20 0 -435 0 -434 -230 0 -230 0 -10 27 c-19 52 -35 76 -68 101 -35 26 -109 40 -157 28 -40 -10 -103 -74 -117 -117 l-11 -39 -57 0 c-43 0 -64 5 -84 21 l-26 20 0 412 c0 408 0 411 22 434 l21 23 447 0 c437 0 448 0 474 -21z m446 -232 c21 -11 138 -178 139 -199 1 -5 -116 -8 -259 -8 l-260 0 0 110 0 110 178 0 c122 0 185 -4 202 -13z m160 -452 l0 -205 -48 0 c-48 0 -49 1 -60 39 -15 49 -79 108 -127 117 -106 20 -186 -30 -219 -139 -4 -12 -16 -17 -46 -17 l-40 0 0 205 0 205 270 0 270 0 0 -205z m-1133 -111 c86 -66 58 -214 -48 -245 -104 -31 -208 69 -179 171 28 99 144 137 227 74z m906 22 c18 -7 45 -28 60 -45 22 -27 27 -42 27 -86 0 -46 -5 -60 -30 -89 -53 -60 -136 -71 -194 -25 -83 66 -70 194 24 241 42 22 70 22 113 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 763 l-147 -146 -79 71 c-79 71 -102 85 -102 59 0 -17 164 -167 182 -167 20 0 322 306 314 319 -4 6 -10 11 -14 11 -4 0 -73 -66 -154 -147z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/Shipped.9ce38da7cb14231d2c150d201367b5f7.svg";
export { ForwardRef as ReactComponent };